import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.size || 18}
            height={props.size || 19}
            viewBox="0 0 18 19"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_701_1390)" fill="#0072C6">
                <path d="M11.264 4.259v3.56l1.244.783c.033.01.104.01.137 0L18 4.992c0-.427-.398-.733-.623-.733h-6.112z" />
                <path d="M11.265 9.147l1.135.78c.16.117.353 0 .353 0C12.56 10.044 18 6.43 18 6.43v6.543c0 .712-.456 1.011-.968 1.011h-5.768V9.147zM5.386 7.506c-.387 0-.695.182-.923.545-.227.363-.341.843-.341 1.441 0 .607.114 1.087.341 1.44.228.353.527.529.896.529.38 0 .683-.172.905-.515.223-.343.335-.82.335-1.429 0-.635-.108-1.129-.324-1.482-.217-.353-.513-.53-.889-.53z" />
                <path d="M0 2.451v13.927L10.595 18.6V.401L0 2.45zm7.09 9.318c-.448.59-1.032.884-1.752.884-.702 0-1.274-.285-1.716-.856-.442-.571-.663-1.315-.663-2.232 0-.969.224-1.752.673-2.35.45-.598 1.044-.898 1.784-.898.7 0 1.265.286 1.697.859.432.573.648 1.327.648 2.264 0 .963-.224 1.74-.671 2.33z" />
            </g>
            <defs>
                <clipPath id="clip0_701_1390">
                    <path
                        fill="#fff"
                        transform="translate(0 .4)"
                        d="M0 0H18V18.1989H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgComponent;
